import { getDefaultRequestOptions } from 'owa-headers';
import { getUserMailboxInfo } from 'owa-client-ids';
import CalendarActionResponse from 'owa-service/lib/contract/CalendarActionResponse';
import enableBirthdayCalendarOperation from 'owa-service/lib/operation/enableBirthdayCalendarOperation';

/**
 * Makes a call to server to disable birthday calendar
 */
export default function enableBirthdayCalendar(): Promise<CalendarActionResponse> {
    return enableBirthdayCalendarOperation(getDefaultRequestOptions(getUserMailboxInfo()));
}
